module.exports = __webpack_public_path__ + "static/img/25.4afbc4fe.png";